import Service from '@ember/service';
import config from 'sh-www/config/environment';
import GhostContentAPI from '@tryghost/content-api'

const SUPPORTED_VERSION = "v5.42";

class GhostService extends Service {
  #ghostApiInstance = null;

  constructor() {
    super();
    this.load();
  }

  get api() {
    return this.#ghostApiInstance;
  }

  load() {
    return this.#ghostApiInstance = new GhostContentAPI({
      url: config.GHOST.appUrl,
      key: config.GHOST.apiKey,
      version: SUPPORTED_VERSION,
    });
  }
}

export default GhostService;
